import {
  Box,
  Button,
  Drawer,
  IconButton,
  Stack,
  styled,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import ButtonCircle from 'src/components/ButtonCircle';
import MenuIcon from '@mui/icons-material/Menu';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import TryOutlinedIcon from '@mui/icons-material/TryOutlined';
import { colors } from 'src/theme/schemes/PureLightTheme';
import PopulatingDataProgressV2 from 'src/components/Retail/PopulatingDataProgressV2';
import Activity from '../../../layouts/SidebarLayout/Header/Top/component/Activity';
import useRefreshObjectList from 'src/hooks/useRefreshObjectList';
import { reducerUpdateOpenAIAssistant } from 'src/features/AIAssistantPosition';
import { toogleSidebar } from 'src/features/sidebarToggleSlice';
import { useLocation, useNavigate } from 'react-router';
import useObjectManagement from 'src/services/useObjectManagement';
import moment from 'moment';
import TranslateContentButton from 'src/layouts/SidebarLayout/Header/Top/component/TranslateContentButton';
import { useTranslation } from 'react-i18next';
// import moment from 'moment';
import { MainContent } from 'src/layouts/SidebarLayout/Sidebar';
import { useEffect } from 'react';

interface ICustomBox {
  isOnTour: boolean;
}

const CustomBox = styled(Box)<ICustomBox>(
  ({ theme, isOnTour }) => `
    max-width: 100vw;
    padding: ${theme.spacing(2, 4)};
    right: 0;
    display: flex;
    flex-direction: column;
    ${!isOnTour && 'z-index: 6;'}
    overflow: hidden;
    background: #fff;
    gap: ${theme.spacing(1)};
`
);

const TopHeaderV2 = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const matchesUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const isB2C = useAppSelector(
    (state) => state.users.project.customerType === 'b2c'
  );
  const { isOnTour } = useAppSelector((state) => state.storeProductTour);
  const refreshObjectList = useRefreshObjectList();
  const project = useAppSelector((state) => state.users.project);
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const isTelkomsel =
    window.location.hostname.includes('tsight') ||
    window.location.hostname.includes('sentrix');

  const { useGetLastUpdatedData } = useObjectManagement();

  const { data: lastUpdatedData } = useGetLastUpdatedData({
    variables: { projectId: project.id },
    skip: !project.id
  });

  const getPagePath = (pathname: string) => {
    const paths = pathname.split('/');
    const isSettingsPage = paths[1] === 'settings';
    const cleanedPaths = paths.slice(1, 3).map(
      (
        path // capitalize and replace _ with space
      ) =>
        t(
          path
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase())
            .toLowerCase()
        )
    );
    const pathWithSeparator = !isSettingsPage
      ? cleanedPaths.join(' > ')
      : cleanedPaths[0];
    return pathWithSeparator;
  };

  const title = getPagePath(pathname);

  const { isOpen: isAIAssistantOpen } = useAppSelector(
    (state) => state.storeAIAssistantPosition
  );
  const sidebarToggle = useAppSelector((state) => state.sidebarToggle.toggle);
  const toggleSidebar = () => {
    dispatch(toogleSidebar(!sidebarToggle));
  };

  const handleOpenAIAssistant = () => {
    dispatch(reducerUpdateOpenAIAssistant(!isAIAssistantOpen));
    if (matchesUpMd) {
      dispatch(toogleSidebar(!sidebarToggle));
    }
  };

  const handleRefresh = () => {
    refreshObjectList();
    // if (title === 'sna') dispatch(reducerUpdatePrun(prunLocal));
  };

  useEffect(() => {
    if (matchesUpMd) {
      dispatch(toogleSidebar(true));
      return;
    }
    dispatch(toogleSidebar(false));
    return;
  }, [matchesUpMd]);

  return (
    <CustomBox sx={{ ...(!matchesUpMd && { padding: 1 }) }} isOnTour={isOnTour}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        {!matchesUpMd && (
          <IconButton onClick={toggleSidebar} aria-label="open drawer">
            <MenuIcon />
          </IconButton>
        )}
        {!matchesUpMd && (
          <Drawer open={sidebarToggle} onClose={toggleSidebar}>
            <MainContent open={sidebarToggle} toggleSidebar={toggleSidebar} />
          </Drawer>
        )}
        <Typography sx={{ flexGrow: !matchesUpMd ? 1 : undefined }}>
          {title}
        </Typography>
        {matchesUpMd && isB2C && <PopulatingDataProgressV2 />}
        <Stack
          direction="row"
          alignItems="center"
          spacing={matchesUpMd ? 2 : 1}
        >
          {/* <Stack gap={0.5} alignItems="center">
          <Typography variant="caption">Last updated:</Typography>
          <Typography fontSize={14} variant="body1">
            {lastUpdatedData?.objectManagement_getLastDataUpdate
              ? moment(
                lastUpdatedData.objectManagement_getLastDataUpdate
              ).format('DD MMM YYYY, HH:mm')
              : '-'}
          </Typography>
        </Stack> */}
          {/* <ButtonCircle sx={{ background: '#F5F5F5' }} onClick={handleRefresh}>
          <Tooltip arrow title="Refresh">
            <RefreshIcon sx={{ color: '#285771' }} />
          </Tooltip>
        </ButtonCircle> */}
          {!isTelkomsel ? (
            <ButtonCircle
              sx={{ background: '#F5F5F5' }}
              onClick={() => navigate('/guide/video_tutorial')}
            >
              <Tooltip arrow title={t('help')}>
                <HelpOutlineIcon sx={{ color: '#285771' }} />
              </Tooltip>
            </ButtonCircle>
          ) : null}

          {/* {project && project.timezone === 7 && <TranslateContentButton />} */}
          <Activity variant="circle" />
          <Button
            variant="contained"
            startIcon={
              matchesUpMd ? (
                <TryOutlinedIcon sx={{ fontSize: '16px !important' }} />
              ) : undefined
            }
            sx={{ background: colors.gradients.purple1, fontWeight: 600 }}
            onClick={handleOpenAIAssistant}
          >
            {matchesUpMd ? (
              'AI Assistant'
            ) : (
              <TryOutlinedIcon sx={{ fontSize: '16px !important' }} />
            )}
          </Button>
        </Stack>
      </Stack>
      {!matchesUpMd && isB2C && <PopulatingDataProgressV2 />}
    </CustomBox>
  );
};

export default TopHeaderV2;
